import commonFunction from "../../lib/utils/common";

const loginB2B = ({ props }) => {
  try {
    const userToken = commonFunction.getCookieTocken("userToken") || "";
    const isB2B = props?.home?.data?.site?.business_b2b;
    const isLoginPage = window.location.pathname === "/login";

    if (isB2B && !userToken && !isLoginPage) {
      window.location.href = "/login";
    }
  } catch (error) {
    console.error("login b2b error", error);
  }
};

export default loginB2B;
